import { render, staticRenderFns } from "./SuperUsers.vue?vue&type=template&id=328d61ad&scoped=true&"
import script from "./SuperUsers.vue?vue&type=script&lang=js&"
export * from "./SuperUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328d61ad",
  null
  
)

export default component.exports